'use client';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useState } from 'react';
import styles from './CategoryOrdering.module.scss';
import { createQueryString } from '@/utils';

const CategoryOrdering = ({
  className,
  handleLinkAttributes = null,
  category,
  parameters,
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const [activeKey, setActiveKey] = useState(
    searchParams.get('orderBy') ||
      process.env.NEXT_PUBLIC_PRODUCT_DEFAULT_ORDERING,
  );

  const handleChange = event => {
    setActiveKey(event.target.value);

    const href = pathname +
      '?' +
      createQueryString(
        'orderBy',
        event.target.value,
        searchParams,
        'page',
      )

      router.push(href);
  };

  return (
    <div className={styles?.filter + ' ' + className}>
      <span className={'hidden lg:block'}>Zoradiť:</span>
      <select value={activeKey} onChange={handleChange}>
        <option value={'real-priority-desc'}>Odporúčane</option>
        <option value={'time-desc'}>Od najnovšieho</option>
        <option value={'price-desc'}>Od najdrahšieho</option>
        <option value={'real-price-asc'}>Od najlacnejšieho</option>
        <option value={'name-asc'}>Abecedne A-Z</option>
        <option value={'name-desc'}>Abecedne Z-A</option>
      </select>
    </div>
  );
};

export default CategoryOrdering;
